import { CasSelect, componentProps } from 'src/compass/shared/components';
import { useFirstOfMonthDateValues } from 'src/compass/application';
import { DateFormat, formatDate } from 'src/compass/shared/util/casMoment';

export function AsOfDateSelect(props: componentProps) {
  const dateValues = useFirstOfMonthDateValues({});
  const datesOptions = dateValues.map((date) => ({
    name: formatDate(date, DateFormat.MDY),
    id: date,
  }));

  return <CasSelect options={datesOptions} {...props} />;
}
